/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Keys_CreatedInputs */

const en_settings_keys_created = /** @type {(inputs: Settings_Keys_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const id_settings_keys_created = /** @type {(inputs: Settings_Keys_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dibuat ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Created {date}" |
*
* @param {Settings_Keys_CreatedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_keys_created = /** @type {((inputs: Settings_Keys_CreatedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Keys_CreatedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_keys_created(inputs)
	return en_settings_keys_created(inputs)
});